/// <reference path="../AppHelper.ts" />

class ChangePasswordViewController extends MUIViewController
{
    static newInstance() : ChangePasswordViewController {
        let vc = new ChangePasswordViewController('change-password-view');
        vc.initWithResource("layout/forgot_password/ChangePasswordView.html");
        return vc;
    }

    private newPasswordTextField:MUITextField = null;
    private retypeNewPasswordTextField:MUITextField = null;

    private cancelButton:MUIButton = null;
    private changePasswordButton:MUIButton = null;

    viewDidLoad() {
        super.viewDidLoad();

        this.newPasswordTextField = MUIOutlet(this, 'new-password-tf', 'MUITextField');
        this.retypeNewPasswordTextField = MUIOutlet(this, 'retype-new-password-tf', 'MUITextField');

        this.cancelButton = MUIOutlet(this, 'cancel-btn', 'MUIButton');
        this.cancelButton.setAction(this, function(this:ChangePasswordViewController){
            MUIWebApplication.sharedInstance().delegate.resetPasswordToken = null;
            this.navigationController.popViewController(true);
        });

        this.changePasswordButton = MUIOutlet(this, 'change-pass-btn', 'MUIButton');
        this.changePasswordButton.setAction(this, function(this:ChangePasswordViewController){
            this.changePassword();
        });
    }

    private changePassword() {        
        if (this.newPasswordTextField.text != this.retypeNewPasswordTextField.text) {
            AppHelper.showErrorMessage(this, "ERROR", MIOLocalizeString("PASSWORDS_DO_NOT_MATCH", "PASSWORDS DO NOT MATCH"));
            return;
        }

        let auth = DualLinkAuthKit.sharedInstance();
        auth.changeUserPasswordWithToken(MUIWebApplication.sharedInstance().delegate.resetPasswordToken, this.newPasswordTextField.text, this.retypeNewPasswordTextField.text, (json:any, error:Error) => {
            if(error == null) {                
                this.showChangePasswordOKViewController();
            }
            else {
                AppHelper.showErrorMessage(this, "ERROR", MIOLocalizeString("THERE_WAS_AN_ERROR_CHANGING_THE_PASSWORD", "There was an error changing the password"));
            }
        });
    }

    private showChangePasswordOKViewController() {
        MUIWebApplication.sharedInstance().delegate.resetPasswordToken = null;
        
        let avc = new MUIAlertViewController();
        avc.initWithTitle(MIOLocalizeString("INFO", "INFO"), MIOLocalizeString("THE_PASSWORD_WAS_CHANGED_SUCCESSFULLY", "THE_PASSWORD_WAS_CHANGED_SUCCESSFULLY"), MUIAlertViewStyle.Default);
        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString('OK','OK'), MUIAlertActionStyle.Default, this, function(this:ChangePasswordViewController){
            this.navigationController.popViewController(true);
        }));
        
        this.presentViewController(avc, true);
    }
}